export const COLUMN_IDS = {
    REPORT_NAME: 'reportName',
    FILENAME: 'filename',
    PRO: 'pro',
    PERFORMANCE_PERIOD: 'performancePeriod',
    CHANNELS_INCLUDED: 'channelsIncluded',
    DATE_CREATED: 'dateCreated',
    VIEW: 'view',
    EDIT: 'edit',
    DOWNLOAD: 'download',
    DELETE: 'delete',
};

export const defaultColumnWidth = 200;
export const rowHeight = 50;

export const columnWidthInputs = {
    [COLUMN_IDS.REPORT_NAME]: {
        min: 250,
    },
    [COLUMN_IDS.PRO]: {
        min: 80,
        max: 80,
    },
    [COLUMN_IDS.PERFORMANCE_PERIOD]: {
        min: 100,
        max: 100,
    },
    [COLUMN_IDS.CHANNELS_INCLUDED]: {
        min: 80,
        max: 80,
    },
    [COLUMN_IDS.DATE_CREATED]: {
        min: 130,
        max: 130,
    },
    [COLUMN_IDS.EDIT]: {
        min: 50,
        max: 50,
    },
    [COLUMN_IDS.VIEW]: {
        min: 50,
        max: 50,
    },
    [COLUMN_IDS.DOWNLOAD]: {
        min: 85,
        max: 85,
    },
    [COLUMN_IDS.DELETE]: {
        min: 50,
        max: 50,
    },
};

export const columnWidthInputsWithFilename = {
    ...columnWidthInputs,
    [COLUMN_IDS.FILENAME]: {
        min: 200,
    },
};
